import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import logo from '../assets/ranky-logo-text-blue-gradient.png';

import '../style/Sidebar.css';

// SidebarComponent Component
class SidebarComponent extends Component {
  render() {
    return(
      <div className="app-sidebar-wrapper">
        <div className="app-sidebar sidebar-shadow">
            <div className="app-header-logo">
                <img className="logo" src={logo} alt="Logo"/>
            </div>
            <div className="scrollbar-sidebar scrollbar-container ps">
                <div className="app-sidebar-inner">
                    <ul className="vertical-nav-menu">
                        <li className="heading">Menu</li>
                        <li>
                            <NavLink className="nav-link" to='/app' exact activeClassName="active">
                                <i className="pe-7s-rocket menu-icon"></i>
                                Accueil
                            </NavLink>
                        </li>
                        <li>
                            <NavLink className="nav-link" to='/app/etablissements' activeClassName="active">
                                <i className="pe-7s-graph2 menu-icon"></i>
                                Mes établissements
                            </NavLink>
                        </li>
                        <li>
                            <NavLink className="nav-link" to='/app/bills' activeClassName="active">
                                <i className="pe-7s-note2 menu-icon"></i>
                                Mes factures
                            </NavLink>

                        </li>
                        <li className="heading">Mon compte</li>
                        <li>
                            <NavLink className="nav-link" to='/app/profile' activeClassName="active">
                                <i className="pe-7s-user menu-icon"></i>
                                Mon profil
                            </NavLink>

                        </li>
                        <li>
                            <NavLink className="nav-link" to='/app/logout' activeClassName="active">
                                <i className="pe-7s-plug menu-icon"></i>
                                Déconnexion
                            </NavLink>

                        </li>
                    </ul>
                </div>
            </div>
        </div>
      </div>
    );
  }
}
export default SidebarComponent;



// WEBPACK FOOTER //
// ./src/components/Sidebar.js